var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"reporting-container"},[(_vm.userCanViewReport === true)?_c('Tabs',{attrs:{"tabs":_vm.tabs,"level":1}}):_vm._e(),(_vm.userCanViewReport === false)?_c('p',[_vm._v(" You don't have permission to view reports. Please contact admin to acquire one. ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }